// src/components/HomeComponent.jsx (or .tsx)
import React from 'react';

function HomeComponent() {
  return (
    <div>
      <h1>Welcome to Your Dashboard Home!</h1>
      <p>This is where you can see an overview or personalized information.</p>
      {/* Add any other content you want for the home page */}
    </div>
  );
}

export default HomeComponent;